/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsRiotAccountBriefDtoSchema = z.object({
  gameName: z.string().nullish(),
  tagLine: z.string().nullish(),
  region: z.string().nullish(),
  isPrimary: z.optional(z.boolean()),
});
